import { registerPlugin } from '@capacitor/core';

const DriveDetector = registerPlugin('DriveDetector');

export default DriveDetector;
